import { forwardRef } from 'react';

import { IconProps } from '.';

export const FormPortraitIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" ref={ref} {...props} {...{ className }}>
      <path
        d="M12.75 13.5C13.1642 13.5 13.5 13.8358 13.5 14.25C13.5 14.6642 13.1642 15 12.75 15H7.25C6.83579 15 6.5 14.6642 6.5 14.25C6.5 13.8358 6.83579 13.5 7.25 13.5H12.75Z"
        fill="currentColor"
      />
      <path
        d="M12.75 10.5C13.1642 10.5 13.5 10.8358 13.5 11.25C13.5 11.6642 13.1642 12 12.75 12H7.25C6.83579 12 6.5 11.6642 6.5 11.25C6.5 10.8358 6.83579 10.5 7.25 10.5H12.75Z"
        fill="currentColor"
      />
      <path
        d="M9.75 7.5C10.1642 7.5 10.5 7.83579 10.5 8.25C10.5 8.66421 10.1642 9 9.75 9H7.25C6.83579 9 6.5 8.66421 6.5 8.25C6.5 7.83579 6.83579 7.5 7.25 7.5H9.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.79 2.01074C12.3053 2.06181 12.7899 2.28987 13.1592 2.65918L15.8174 5.31738C16.2363 5.70552 16.5 6.25886 16.5 6.875V15.75C16.5 16.9926 15.4926 18 14.25 18H5.75C4.50736 18 3.5 16.9926 3.5 15.75V4.25C3.5 3.00736 4.50736 2 5.75 2H11.5684L11.79 2.01074ZM5.75 3.5C5.33579 3.5 5 3.83579 5 4.25V15.75C5 16.1642 5.33579 16.5 5.75 16.5H14.25C14.6642 16.5 15 16.1642 15 15.75V6.93164C14.9999 6.78251 14.9556 6.63788 14.874 6.51562L14.7822 6.40332C14.6727 6.30866 14.5311 6.25 14.375 6.25H13C12.5858 6.25 12.25 5.91421 12.25 5.5V4.25C12.25 3.83579 11.9142 3.5 11.5 3.5H5.75Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default FormPortraitIcon;
